export default __webpack_public_path__ + "static/media/logo.b771e8ba.svg";